import type { StockChoice } from "../api/client";

type Props = {
  choices: StockChoice[];
  value: string;
  disabled?: boolean;
  onChange: (symbol: string) => void;
};

export function StockStickerPicker({ choices, value, disabled, onChange }: Props) {
  return (
    <div className="stock-stickers" role="group" aria-label="Choose a stock symbol">
      <p className="stock-stickers-label">Select a stock</p>
      <div className="stock-stickers-row">
        {choices.map((choice) => {
          const active = choice.symbol === value;
          return (
            <button
              key={choice.symbol}
              type="button"
              className={`stock-sticker${active ? " stock-sticker--active" : ""}`}
              disabled={disabled}
              aria-pressed={active}
              title={choice.label}
              onClick={() => onChange(choice.symbol)}
            >
              <span className="stock-sticker-symbol">{choice.symbol}</span>
              {choice.label !== choice.symbol && (
                <span className="stock-sticker-name">{choice.label.replace(/\s*\([^)]+\)\s*/, "")}</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
